import React, { Component } from "react";
import { connect } from "react-redux";

import { ToastContainer, toast } from "react-toastify";

import { setCurrentNavPage, setFilter } from "Actions";
import { fetchTrees } from "thunks";

import CategoriesListComponent from "./CategoriesListComponent";
import DeleteConfirm from "Common/Confirm/DeleteConfirm";
import { setOpenDeleteConfirm } from "Actions";
import { deleteTree } from "Thunks";

import _ from "i18n";

export class CategoriesList extends Component {
  componentDidMount() {
    const { fetchTrees, setFilter } = this.props;
    fetchTrees({});
    setFilter({ category: "" });
  }

  handleDeleteTree = () => {
    const { currentTreeId, deleteTree, setOpenDeleteConfirm } = this.props;

    deleteTree(currentTreeId)
      .then(resp => {
        setOpenDeleteConfirm(false);
        toast.success(
          <div class="flashMessage">
            <div class="flahMessage__icon">
              <i className="icotam-check-outline" />
            </div>
            <div className="flashMessage__body">
              <h5>{_("Success")}</h5>
              <p>{_("Tree deleted successfully")}</p>
            </div>
          </div>
        );
        return resp;
      })
      .catch(e => {
        setOpenDeleteConfirm(false);
        toast.error(
          <div class="flashMessage">
            <div class="flahMessage__icon">
              <i className="icotam-close-outline" />
            </div>
            <div className="flashMessage__body">
              <h5>{_("Error")}</h5>
              <p>{_("Could not delete the Tree")}</p>
            </div>
          </div>
        );
      });
  };

  cancelDeleteTree = () => {
    const { setOpenDeleteConfirm } = this.props;
    setOpenDeleteConfirm(false);
  };

  renderDeleteModal() {
    const { openDeleteConfirm, deleting } = this.props;

    return (
      <DeleteConfirm
        isOpen={openDeleteConfirm}
        onCancel={this.cancelDeleteTree}
        onConfirm={this.handleDeleteTree}
        deleting={deleting}
        text={_("Are you sure you want to delete the tree ?")}
      />
    );
  }

  render() {
    return (
      <div>
        <CategoriesListComponent {...this.props} />
        {this.renderDeleteModal()}
        <ToastContainer hideProgressBar />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  fetching: state.trees.fetching,
  trees: state.trees.items,
  currentTreeId: state.trees.currentTreeId,
  openDeleteConfirm: state.trees.openDeleteConfirm,
  deleting: state.trees.deleting,
  lng: state.params.lng
});

const mapDispatchToProps = dispatch => ({
  setCurrentNavPage: options => dispatch(setCurrentNavPage(options)),
  fetchTrees: params => dispatch(fetchTrees(params)),
  deleteTree: id => dispatch(deleteTree(id)),
  setFilter: filter => dispatch(setFilter(filter)),
  setOpenDeleteConfirm: visible => dispatch(setOpenDeleteConfirm(visible))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoriesList);



// WEBPACK FOOTER //
// ./src/components/CategoriesList/index.js